import { Alert, Button, Divider, InputNumber, Row, Space } from 'antd';
import cn from 'classnames';
import React, { useContext } from 'react';

import { PREFIX } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import { ClientFiltersContext } from '@app/providers';

import { hideFilterBlock } from '@pages/Clients/ClientsList/utils';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

import '@pages/Clients/ClientsList/styles/RangeWithStartAndEnd.desktop.scss';

// TODO: в будущем переиспользовать этот компонент также для фильтров
// "Количество записей" и "Сумма оказанных услуг"
export const RangeWithStartAndEnd: NClientsList.RangeWithStartAndEnd = ({
  labelClassName,
  minValue,
  maxValue,
  filterGroupKey,
  filterUnitKey,
  filterUnitMaxKey,
  filterGroupIndex,
  handleMinChange,
  handleMaxChange,
  min,
  max,
  fieldClassName,
  tip = undefined,
  withNegativeValues = false,
}) => {
  const { handleDisabling, setUpServerDataChunk } =
    useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const condition = withNegativeValues
      ? event.key === '+'
      : event.key === '-' || event.key === '+';

    if (condition) {
      event.preventDefault();
    }
  };

  return (
    <div
      className={`${PREFIX}range-with-start-and-end`}
      onClick={(e: MouseEvent | React.MouseEvent) => e.stopPropagation()}
    >
      <Space direction="vertical">
        {tip && <Alert message={tip} type="info" showIcon />}
        <Space>
          <InputNumber
            className={cn('range-value', {
              [`${fieldClassName}`]: fieldClassName,
            })}
            controls={false}
            addonBefore="от"
            type="number"
            value={minValue}
            onChange={handleMinChange}
            min={min}
            max={max}
            onKeyDown={handleKeyDown}
          />
          <InputNumber
            className={cn('range-value', {
              [`${fieldClassName}`]: fieldClassName,
            })}
            controls={false}
            addonBefore="до"
            type="number"
            value={maxValue}
            onChange={handleMaxChange}
            min={min}
            max={max}
            onKeyDown={handleKeyDown}
          />
        </Space>
      </Space>
      <Divider style={{ marginTop: '8px', marginBottom: '12px' }} />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            filterGroupKey,
            filterUnitKey,
            true,
            filterUnitMaxKey,
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              filterGroupKey,
              filterUnitKey,
              true,
              filterUnitMaxKey,
              filterGroupIndex
            );

            hideFilterBlock(`.${labelClassName}`, innerWidth, filterGroupIndex);
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
